module.exports = __webpack_public_path__ + "assets/img/driver-active-btn-0553e666.png";